import { getPhoto, getPhotos } from 'shop-components/api/photo'

export const fetchPhoto = (id) => (dispatch) => {
  dispatch({
    type: 'PRODUCT_IMAGES_FETCH_START'
  })

  getPhoto(id)
    .then(({ data: { data } }) => {
      const photo = {
        id: data.id,
        ...data.attributes
      }

      dispatch({
        type: 'PRODUCT_IMAGES_FETCH_SUCCESS',
        payload: { records: [photo] }
      })
    })
    .catch(() => {
      dispatch({
        type: 'PRODUCT_IMAGES_FETCH_ERROR'
      })
    })
}

export const fetchPhotos = (ownerId) => (dispatch) => {
  dispatch({
    type: 'PRODUCT_IMAGES_FETCH_START'
  })

  getPhotos({ ownerId })
    .then(({ data: { data } }) => {
      const records = data.map(({ id, attributes }) => ({
        id,
        ...attributes
      }))

      dispatch({
        type: 'PRODUCT_IMAGES_FETCH_SUCCESS',
        payload: { records }
      })
    })
    .catch(() => {
      dispatch({
        type: 'PRODUCT_IMAGES_FETCH_ERROR'
      })
    })
}
